<div class="flex flex-col gap-5">
  <div
    class="bg-grey-skeleton animate-pulse h-[170px] max-sm:h-[100px] w-full rounded-8 object-cover"
  ></div>
  <div class="flex flex-col gap-2 font-roboto-400 text-12">
    <div class="bg-grey-skeleton animate-pulse w-full h-[20px]"></div>
    <div class="bg-grey-skeleton animate-pulse w-[50%] h-[20px]"></div>
    <div class="bg-grey-skeleton animate-pulse w-full h-[20px]"></div>
  </div>
  <div class="flex flex-col gap-2 font-roboto-400 text-12">
    <div class="bg-grey-skeleton animate-pulse w-full h-[15px]"></div>
    <div class="bg-grey-skeleton animate-pulse w-[30%] h-[15px]"></div>
  </div>
</div>
